import React from 'react';
import PropTypes from 'prop-types';

export default class DataMapper extends React.Component {
	constructor(props) {
		super(props);
		this.state = { appIsMounted: null };
	}

	async componentDidMount() {
		const { mapping = {} } = this.props;

		/*
			Create array of projects,utils with configuration that has utils set to true:
			[{
				utils: <pending promise>
				project: 'blast'
			}]
		*/
		const projectUtils = [];
		Object.entries(mapping).forEach(
			([
				project,
				{
					configuration: { utils = false },
					grouping
				}
			]) =>
				utils &&
				projectUtils.push({
					utils: import(`../utils/${grouping}/utils`),
					project
				})
		);

		/*
			Get resolved utils modules
		*/
		const modules = await Promise.all(
			projectUtils.map(async promise => promise.utils)
		);

		/*
			Loop through modules and add the utils
		*/
		modules.forEach(({ project, ...functions }) => {
			window.DDC.WidgetData['ws-tagging'].mapping[
				project
			].utils = functions;
		});

		await import('../utils/dataMapper');
		this.setState({
			appIsMounted: true
		});
	}

	render() {
		return this.state.appIsMounted ? <span /> : null;
	}
}

DataMapper.propTypes = {
	mapping: PropTypes.objectOf(PropTypes.object)
};
